import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import {
  CustomRemindDialogComponent,
  CustomRemindDialogFieldType,
} from '@main-application/inspections/components/inspection-add-dialog/custom-remind-dialog/custom-remind-dialog.component';
import { DueDateBaseDate } from '@main-application/inspections/models/rest-inspections-model.interface';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { InputModule } from '@ui-components/controls/input/input.module';
import { RadioButtonDropdownModule } from '@ui-components/controls/radio-button-dropdown/radio-button-dropdown.module';

export const CREATION_DATE_ID = 100000;

export interface CustomNotificationDialogResponse {
  days: number;
  isCreationDate: boolean;
}

@Component({
  selector: 'app-ticket-custom-notification-fields-dialog',
  standalone: true,
  imports: [
    CommonModule,
    RadioButtonDropdownModule,
    MatButtonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    InputModule,
  ],
  templateUrl: './ticket-custom-notification-fields-dialog.component.html',
  styleUrls: [
    '../ticket-custom-notification-dialog/ticket-custom-notification-dialog.component.scss',
    './ticket-custom-notification-fields-dialog.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketCustomNotificationFieldsDialogComponent implements OnInit {
  title = 'Custom Notify on';
  public data: {
    fieldType: CustomRemindDialogFieldType;
    existingBeforeAfter?: string;
    existingDays?: number;
    stepName?: string;
    existingDueDateBaseDate?: DueDateBaseDate;
  } = inject(MAT_DIALOG_DATA);

  beforeAfterItems: IRadioButtonOption<number>[] = [
    {
      value: CREATION_DATE_ID,
      label: `After the creation date`,
    },
    {
      value: -1,
      label: `Before the due date`,
    },
    {
      value: 1,
      label: `After the due date`,
    },
  ];

  beforeAfterControl = new UntypedFormControl(-1);
  daysControl = new UntypedFormControl(null, [
    Validators.required,
    Validators.max(1000),
    Validators.min(1),
    Validators.pattern(/^\d+$/),
  ]);
  formSubmitted = false;

  constructor(private dialogRef: MatDialogRef<CustomRemindDialogComponent>, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.title = this.setTitle(this.data.fieldType);
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.formSubmitted = true;

    if (this.daysControl.valid) {
      const result = +this.daysControl.value * this.beforeAfterControl.value;
      this.dialogRef.close({
        days: result,
        isCreationDate: this.beforeAfterControl.value === CREATION_DATE_ID,
      } as CustomNotificationDialogResponse);
    }
  }

  private setTitle(fieldType: CustomRemindDialogFieldType): string {
    switch (fieldType) {
      case 'notifyOn':
        return 'Notify on';
      case 'remindOn':
        return 'Remind on';
    }
    return 'Notify on';
  }
}
